
<ng-template  [ngIf]="item" >
<div class="treeview-item">
    <div class="form-inline row-item" style="display: ruby">

        <ng-template  [ngIf]="item.children">
        <a class="naked emprez-duo-icon" style="margin-right: 0.3rem" (click)="onCollapseExpand()">
            <ng-template [ngIf]="!item.collapsed"><i class="fad fa-caret-down fa-lg"></i></ng-template>
            <ng-template [ngIf]="item.collapsed"><i class="fad fa-caret-right fa-lg"></i></ng-template>
        </a>
        </ng-template>

        <div class="form-check">
            <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()"
                   [disabled]="item.disabled" [indeterminate]="item.indeterminate" />
            <label class="form-check-label" (click)="item.checked = !item.checked; onCheckedChange()">
                {{item.text}}
            </label>
        </div>
    </div>

    <!--  {{item.text}} {{item.value}}-->
    <ng-template [ngIf]="!item.collapsed">
        <div>
            <treeItem *ngFor="let child of item.children" [ngModel]="child"
                      (checkedChange)="onChildCheckedChange(child, $event)">
            </treeItem>
        </div>
    </ng-template>
</div>
</ng-template>


